module.exports = __webpack_public_path__ + "img/4_171.24c61d1e.png";